import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Header from './Header.jsx';
import Footer from './Footer.jsx';
import SubscriptionBanner from './SubscriptionBanner.jsx';
import AppNavigation from './AppNavigation.jsx';
import { HeaderProvider, useHeader } from '../contexts/HeaderContext';

function LayoutContent({ children }) {
  const location = useLocation();
  const { currentUser } = useAuth();
  const { headerOptions } = useHeader();
  const isPreviewRoute = location.pathname === '/demo-preview';
  // Hide header/footer for /p/:handle
  const isHandlePreview = /^\/p\/[a-zA-Z0-9\-]{4,}$/.test(location.pathname);
  // Hide footer for pitch builder
  const isPitchBuilder = /^\/pitch-builder\/[a-zA-Z0-9\-]+$/.test(location.pathname);
  // Hide footer for dashboard when signed in
  const isDashboard = location.pathname === '/dashboard' && currentUser;
  const isPitchBuilderRoute = /^\/pitch-builder\/[a-zA-Z0-9\-]+$/.test(location.pathname);

  // Routes that should use the new AppNavigation
  const appNavigationRoutes = [
    '/companies',
    '/investor-tracker',
    '/accelerator-tracker',
    '/workspace-settings',
    '/settings',
    '/subscription'
  ];

  const shouldUseAppNavigation = appNavigationRoutes.some(route => {
    if (route === '/companies') {
      return location.pathname === '/companies';
    }
    if (route === '/settings') {
      return location.pathname === '/settings';
    }
    if (route === '/subscription') {
      return location.pathname === '/subscription';
    }
    if (route === '/workspace-settings') {
      return location.pathname === '/workspace-settings';
    }
    return location.pathname.startsWith(route);
  });

  // If it's an app navigation route, use the new navigation
  if (shouldUseAppNavigation) {
    return (
      <AppNavigation>
        {children}
      </AppNavigation>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-slate-900">
      {!isHandlePreview && (
        <Header
          {...(isPitchBuilderRoute
            ? {
                showHamburger: headerOptions.showHamburger,
                onHamburgerClick: headerOptions.onHamburgerClick,
                sectionTitle: headerOptions.sectionTitle,
              }
            : { showHamburger: false, sectionTitle: '' }
          )}
        />
      )}
      {currentUser && !isHandlePreview && <SubscriptionBanner />}
      <main className="flex-grow">
        {children}
      </main>
      {!(isPreviewRoute || isHandlePreview || isPitchBuilder || isDashboard) && <Footer />}
    </div>
  );
}

function Layout({ children }) {
  return (
    <HeaderProvider>
      <LayoutContent>{children}</LayoutContent>
    </HeaderProvider>
  );
}

export default Layout; 